<script setup lang="ts">
	import { computed } from 'vue'

	interface Props {
		currencyCode: string
		validationErrors: {
			default: string
		}
		attemptedToSubmit?: boolean
	}

	defineProps<Props>()

	const selectedPaymentMethod = defineModel<string>('selectedPaymentMethod')
	const termsAccepted = defineModel<boolean>({ default: false })

	const selectPayment = computed(() => {
		return (
			selectedPaymentMethod.value === 'userCards' ||
			selectedPaymentMethod.value === 'companyCard'
		)
	})
</script>

<template>
	<div class="bg-white rounded-xl border border-gray-200 overflow-hidden">
		<div class="p-4 lg:p-6">
			<div class="flex items-start gap-3 lg:gap-4">
				<div class="flex-1 min-w-0">
					<div class="flex items-center gap-2">
						<input
							id="terms"
							v-model="termsAccepted"
							type="checkbox"
							class="mt-1 h-4 w-4 lg:h-5 lg:w-5 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500 focus:ring-2 checked:bg-blue-600 checked:border-blue-600 transition-colors duration-200"
						/>
						<label
							for="terms"
							class="font-inter text-xs lg:text-sm text-gray-700 font-medium cursor-pointer"
						>
							Acepto que he leído y estoy de acuerdo con los términos y
							condiciones de cancelación del hotel.
						</label>
					</div>

					<ul
						class="mt-3 lg:mt-4 space-y-2 text-xs lg:text-sm text-gray-600 font-inter"
						v-show="selectPayment"
					>
						<li class="flex items-start gap-2">
							<svg
								class="w-3 h-3 lg:w-4 lg:h-4 text-gray-400 mt-0.5 flex-shrink-0"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M9 12l2 2 4-4"
								></path>
							</svg>
							<span class="flex-1"
								>Las transacciones son procesadas por Openpay y están sujetas a
								su propio aviso de privacidad y términos de servicio.</span
							>
						</li>
						<li
							v-if="currencyCode !== 'MXN'"
							class="flex items-start gap-2"
						>
							<svg
								class="w-3 h-3 lg:w-4 lg:h-4 text-gray-400 mt-0.5 flex-shrink-0"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M9 12l2 2 4-4"
								></path>
							</svg>
							<span class="flex-1"
								>El monto final estará sujeto al tipo de cambio vigente el día
								de registro, ya que la tarifa está expresada en
								{{ currencyCode }}.</span
							>
						</li>
					</ul>

					<span
						v-if="attemptedToSubmit && !termsAccepted"
						class="block mt-2 lg:mt-3 text-xs lg:text-sm text-red-600 font-inter"
					>
						{{ validationErrors.default }}
					</span>
				</div>
			</div>
		</div>
	</div>
</template>
